// extracted by mini-css-extract-plugin
module.exports = {"root":"form_subtitle_root__2Xy39"};